export var AiAssistantFeatureTypes;
(function (AiAssistantFeatureTypes) {
    AiAssistantFeatureTypes["Title"] = "title";
    AiAssistantFeatureTypes["Summary"] = "summary";
    AiAssistantFeatureTypes["ActionPoints"] = "action_points";
    AiAssistantFeatureTypes["Combined"] = "combined";
})(AiAssistantFeatureTypes || (AiAssistantFeatureTypes = {}));
